export const normalizeRef = (input) => (input || '').replace(/[^A-Za-z0-9-]/g, '').toUpperCase();
export const normalizePhone = (input) => (input || '').replace(/[^0-9]/g, '');
export const isValidEmailFormat = (email) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((email || '').trim());
export const isValidPhoneFormat = (phone) => /^\d{10}$/.test((phone || '').trim());
